import state from "../state";
import * as Utils from "../utils/utils.js";
import PlayerPaths from "../constants/paths/playerPaths.js";
import _ from "lodash";

class RuntimeApi {

	setGlobalVar(name, value) {
		state.set(PlayerPaths.GLOBAL_VARS(name), value);
	}

	getGlobalVar(name) {
		return state.get(PlayerPaths.GLOBAL_VARS(name));
	}

	findCurrentList() {
		let selectedListIndex = state.get(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX);

		return {
			node: state.get(PlayerPaths.ACTIVITY_LIST(selectedListIndex)),
			path: PlayerPaths.ACTIVITY_LIST(selectedListIndex)
		};
	}

	findCurrentSection() {
		let selectedListIndex = state.get(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX);
		let selectedSectionIndex = state.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);

		return {
			node: state.get(PlayerPaths.ACTIVITY_SECTION(selectedListIndex, selectedSectionIndex)),
			path: PlayerPaths.ACTIVITY_SECTION(selectedListIndex, selectedSectionIndex)
		};
	}

	findCurrentItem() {
		let selectedListIndex = state.get(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX);
		let selectedSectionIndex = state.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
		let selectedItemIndex = state.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);

		return {
			node: state.get(PlayerPaths.ACTIVITY_ITEM(selectedListIndex, selectedSectionIndex, selectedItemIndex)),
			path: PlayerPaths.ACTIVITY_ITEM(selectedListIndex, selectedSectionIndex, selectedItemIndex)
		};
	}

	findListById(id=null) {
		if (_.isUndefined(id) || id === null) {
			return this.findCurrentList();
		} else {
			let nodeIndex = state.get(["idMap", id]);
			if (nodeIndex) {
				return {
					node: state.get(PlayerPaths.ACTIVITY_SECTION(nodeIndex.listIndex)),
					path: PlayerPaths.ACTIVITY_SECTION(nodeIndex.listIndex)
				}; 
			}
		}

		return {node: null, path: []};
	}

	findSectionById(id=null) {
		if (_.isUndefined(id) || id === null) {
			return this.findCurrentSection();
		} else {			
			let nodeIndex = state.get(["idMap", id]);
			if (nodeIndex) {
				return {
					node: state.get(PlayerPaths.ACTIVITY_SECTION(nodeIndex.listIndex, nodeIndex.sectionIndex)),					
					path: PlayerPaths.ACTIVITY_SECTION(nodeIndex.listIndex, nodeIndex.sectionIndex)
				};
			}
		}

		return { node: null, path: [] };
	}

	findItemById(id = null) {
		if (_.isUndefined(id) || id === null) {
			return this.findCurrentItem();
		} else {
			id = id.replace("#", ""); // Remove it if still there
			let nodeIndex = state.get(["idMap", id]);

			const { listIndex, sectionIndex, itemIndex } = nodeIndex;
			if (nodeIndex) {
				return {
					node: state.get(PlayerPaths.ACTIVITY_ITEM(nodeIndex.listIndex, nodeIndex.sectionIndex, nodeIndex.itemIndex)),
					path: PlayerPaths.ACTIVITY_ITEM(nodeIndex.listIndex, nodeIndex.sectionIndex, nodeIndex.itemIndex),
					listIndex,
					sectionIndex,
					itemIndex
				};
			}
		}

		return { node: null, path: [] };
	}

	findNodeById(id=null) {
		if (_.isUndefined(id) || id === null) {
			return this.findCurrentItem();
		} else {
			Utils.findNodeById(state, id);
			return Utils.getLastFoundNode();
		}
	}

	isChecked(id) {
		const {node} = this.findItemById(id);

		if (node) {
			return node.checked;
		} else {
			return null;
		}
	}

	getValue(id) {
		const { node } = this.findItemById(id);
		if (node) {
			// alert(node.value);
			return node.value;
		} else {
			return null;
		}
	}

	getLists() {
		return state.get(PlayerPaths.ACTIVITY_LISTS);
	}

	getSections(listId) {
		const { node } = this.findListById(listId);

		return node.children;
	}

	getItems(sectionId) {
		const { node } = this.findSectionById(sectionId);

		return node.children;
	}

	setVisible(id, visible = true) {
		const { node, path } = this.findNodeById(id);
		
		if (node) {
			//node.visible = visible;	
			state.set(_.concat(path, "visible"), visible);
			// Need to refresh entire screen if change section
			// if (node.type === "section") {
			// 	this.forceRefresh();
			// }
		}

	}

	setHidden(id) {
		this.setVisible(id,false);
	}

	setGroupVisible(groupName) {
		let group = state.get(["groups", groupName]);

		//var foundSection = false;

		for (let i = 0; i < group.length; i++) {
			Utils.findNodeByGuid(state, group[i].guid);
			const { node, path } = Utils.getLastFoundNode();
			
			if (node) {
				state.set(_.concat(path, "visible"), true);
			}
			//node.visible = true;

			// if (node.type === "section") {
			// 	foundSection = true;
			// }
		}
		// if (foundSection) {
		// 	this.forceRefresh();
		// }
	}

	setGroupHidden(groupName) {
		let group = state.get(["groups", groupName]);

		for (let i = 0; i < group.length; i++) {
			Utils.findNodeByGuid(state, group[i].guid);
			const { node, path } = Utils.getLastFoundNode();

			if (node) {
				state.set(_.concat(path, "visible"), false);
			}
		}
	}

	setEnabled(id, enabled=true) {
		const { node, path } = this.findNodeById(id);
		
		if (node) {
            state.set(_.concat(path, "enabled"), enabled);
			// node.enabled = enabled;	
			// // Need to refresh entire screen if change section
			// if (node.type === "section") {
			// 	this.forceRefresh();
			// }
		}

	}

	setDisabled(id) {
		this.setEnabled(id,false);
	}

	setListTitle(id, title) {
		const { node, path } = this.findNodeById(id);
		
		if (node) {
			if (node.hasOwnProperty("title")) {
                state.set(_.concat(path, "title"), title);
				// node.title = title;	
			}
		}
	}

	setSectionTitle(id, title) {
		const { node, path } = this.findNodeById(id);
		
		if (node) {
			if (node.hasOwnProperty("section")) {
                state.set(_.concat(path, "title"), title);
				// node.title = title;	
			}
		}
	}

	setItemLabel1(id, label) {
		const { node, path } = this.findNodeById(id);
		if (node) {
			if (node.hasOwnProperty("label1")) {
                state.set(_.concat(path, "label1"), label);
				// node.label1 = label;	
			}
		}
	}

	setItemLabel2(id, label) {
		const { node, path } = this.findNodeById(id);
		
		if (node) {
			if (node.hasOwnProperty("label2")) {
                state.set(_.concat(path, "label2"), label);
				// node.label2 = label;	
			}
		}
	}

	forceRefresh() {
		state.set(["session"], state.get(["session"]) + 1);
	}
}

export default new RuntimeApi();